<template>
    <checker-detail-row v-if="arrangementFee">
        <div slot="left">
            <span>
                Arrangement Fee:
            </span>
            <a
                :title="arrangementFeeTooltip"
                href="#"
                class="tooltip-icon"
                data-toggle="tooltip"
                data-container="body"
                data-placement="top"
                @click.prevent
            >
                <i class="icons8-info"/>
            </a>
        </div>
        <div slot="right">
            <span class="text-green">
                &pound;{{ arrangementFee | currencyFormat }}
            </span>
        </div>
    </checker-detail-row>
</template>

<script>
    import CheckerDetailRow from '../CheckerDetailRow';
    import { mapGetters } from 'vuex';

    export default {
        name: 'arrangement-fee',

        components: { CheckerDetailRow },

        computed: {
            ...mapGetters('booking', [
                'arrangementFee',
            ]),

            /**
             * Arrangement fee's information.
             *
             * @returns {string}
             */
            arrangementFeeTooltip() {
                return 'The arrangement fee is a one-time charge to help us cover the cost of setting up the long-term booking, including administrative costs and the seamless integration with the site’s enforcement provider.';
            },
        },

        mounted() {
            $('[data-toggle="tooltip"]').tooltip({
                trigger: 'hover',
            });
        },
    };
</script>

<style lang="less" scoped>
    @import "~assets/less/variables.less";

    .tooltip-icon {
        font-size: 16px;
        margin-left: 1px;
        font-weight: 500;
        color: #8697a0;
        vertical-align: text-top;
        display: none;

        @media (min-width: @screen-sm-min) {
            display: inline-block;
        }
    }

    .checker-detail-row ::v-deep .checker-detail-left div {
        display: flex;
        gap: 5px;
    }
</style>
